import { combineReducers } from "redux";
import worklist from "./worklistReducer";
import submittedForVerificationReducer from "./submittedForVerificationReducer";
import parkedReducer from "./parkedReducer";
import verifiedReducer from "./verifiedReducer";
import submittedToTypistReducer from "./submittedToTypistReducer";
import reportViewerReducer from "./reportViewerReducer";
import coReportersReducer from "./coReportersReducer";

const misReducer = combineReducers({
    worklist: worklist,
    submittedForVerification: submittedForVerificationReducer,
    parked: parkedReducer,
    verified: verifiedReducer,
    reportViewer: reportViewerReducer,
    submittedToTypist: submittedToTypistReducer,
    coReporters: coReportersReducer
});

export default misReducer;
